import { apiRequest, performRequest, apiEndPoints, methodType } from "./_apiConfig";
import { postFormWithPasswordPrompt } from "./pdf_upload";

export const getLoanRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.createLoan,
    data,
    true
  );
};

export const updateLoanRequest = async (data = {}, id) => {
  return apiRequest(
    methodType.PATCH,
    `${apiEndPoints.createLoan}/${id}`,
    data,
    true,
    true
  );
};

export const getEvaluation = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.evaluation,
    data,
    true
  );
};

export const getSettlementBankAccounts = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.settlementBankAcount,
    data,
    true
  );
};

export const updateBankAccountRequest = async (data = {}, id) => {
  return postFormWithPasswordPrompt(
    `${apiEndPoints.settlementBankAcount}/${id}`,
    data,
    { method: methodType.PATCH }
  );
};

export const createBankAccountRequest = async (data = {}) => {
  return postFormWithPasswordPrompt(apiEndPoints.settlementBankAcount, data);
};

export const validateIban = async (data = {}) => {
  return apiRequest(
    methodType.POST,
    apiEndPoints.validateIban,
    data,
    false
  );
};

export const getVirtualAccountsRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.virtualAccount(data?.loanId),
    data,
    true
  );
};

export const uploadVirtualAccountDocument = async (data = {}, loanId, vaId) => {
  return postFormWithPasswordPrompt(
    apiEndPoints.virtualAccountDocument(loanId, vaId),
    data
  );
};

export const deleteVaDocumentRequest = async (data = {}, loanId, vaId, documentId) => {
  return apiRequest(
    methodType.DELETE,
    `${apiEndPoints.virtualAccountDocument(loanId, vaId)}/${documentId}`,
    data,
    true
  );
};

export const createAdditionalLoan = async (payload) => {
  return apiRequest(
    methodType.POST,
    apiEndPoints.createAdditionalLoan,
    payload,
    true
  );
};



export const getLoanSummary = async (loanUUID) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.loanSummary,
    { loan_uuid: loanUUID },
    true
  );
};

export const getRepaymentSchedule = async (loanUUID) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.repaymentSchedule,
    { loan_uuid: loanUUID },
    true
  );
};


export const getLoanTransactions = async (payload) => {
  return apiRequest(
    methodType.POST,
    apiEndPoints.transactions,
    payload,
    true
  );
};

export const getStatementEntries = async (loanUUID, order) => {
  const params = { loan_uuid: loanUUID };
  if (order) {
    params.order = order;
  }
  return apiRequest(
    methodType.GET,
    apiEndPoints.getStatementEntries,
    params,
    true
  );
};

export const downloadStatementReport = async (payload = {}) => {
  return performRequest(
    methodType.POST,
    apiEndPoints.statementReport,
    payload,
    true,
    false,
    { responseType: "blob" }
  );
};

export const downloadSOAReport = async (loanUUID, format = "xlsx") => {
  return performRequest(
    methodType.POST,
    apiEndPoints.statementOfAccount(loanUUID),
    { format },
    true
  );
};

export const downloadRepaymentScheduleReport = async (payload = {}) => {
  return performRequest(
    methodType.POST,
    apiEndPoints.repaymentScheduleReport,
    payload,
    true,
    false,
    { responseType: "blob" }
  );
};

